import { ref, computed } from 'vue';
import $ from 'jquery';

import gtmTrace from '@global/gtm/trace';
import { fireShopContentView } from '@global/gtm/product';
import { fireAddToCart } from '@global/gtm/common';
import fireWishlistEvent from '@global/gtm/wishlist';

import { defineStore } from 'pinia';
import useMiniCartStore from '@global/stores/useMiniCartStore';

import useUtmKDetect from '@global/composable/useUtmKDetect';
import useAlert from '@global/composable/useAlert';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';
import useModalStore from '@global/stores/useModalStore';
import useMsg from '@global/composable/useMessage';

import { btnDescriptionEnum, btnFoodDescriptionEnum, btnStyleEnum } from '@/models/productEnum';

const {
  postFavoriteAPI,
  deleteFavoriteAPI,
  getSeriesDataAPI,
  getDataAPI,
  getBrandRecommendDataAPI,
  getRecommendDataAPI,
  getMarketRecommendDataAPI,
  postShoppingCartAPI,
} = useAxiosAPI();

const { utmKDetect, shareCode } = useUtmKDetect();
const { alertDialog } = useAlert();

const useShopContentStore = defineStore('shopContent', () => {
  const miniCartStore = useMiniCartStore();
  const { getCartInfo } = miniCartStore;
  const modalStore = useModalStore();
  const { openModal } = modalStore;
  const { messageBox } = useMsg();

  const dataIsLoad = ref(false);
  const itemDatas = ref({});
  const pattern = ref(window.Pattern);
  const selectedDataID = ref(0);
  const selectedFoodSpec = ref([]);
  const userSelectFlavor = ref({});
  const btnStyleGenerate = ref(btnStyleEnum.disabled);
  const btnDescriptionGenerate = ref(btnDescriptionEnum.general);
  const pzBuyNow = ref(btnDescriptionEnum.general);
  const isOpenStockDialog = ref(false);
  const isOpenCartDialog = ref(false);
  const listName = ref('產品內頁');

  // 改寫在這

  function getDataFromId(id, name = '') {
    dataIsLoad.value = false;
    listName.value = name;
    getDataAPI({
      params: {
        CustomMarketID: id,
      },
    })
      .then((res) => {
        if (res.data.Code === 200) {
          itemDatas.value = res.data.Response;
          selectedDataID.value = res.data.Response.ColorID;

          if (itemDatas.value.IsPreShow) {
            btnStyleGenerate.value = btnStyleEnum.disabled;
            btnDescriptionGenerate.value = btnDescriptionEnum.preShow;
            pzBuyNow.value = btnDescriptionEnum.preShow;
          }

          dataIsLoad.value = true;

          if (window.PictureContainer === 'urliving' || window.PictureContainer === 'urliving-t') {
            getBrandRecommendData();
          }
          isOpenCartDialog.value = true;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function getData() {
    dataIsLoad.value = false;
    if (pattern.value === 2) {
      getSeriesDataAPI({
        params: {
          MarketID: window.MarketID,
        },
      })
        .then((res) => {
          if (res.data.Code === 200) {
            itemDatas.value = res.data.Response;

            setSelectedFood({ foodFlavors: res.data.Response.Flavors, type: false });
            foodBtnStyleGenerate();
            resetCounter();

            dataIsLoad.value = true;

            if (
              window.PictureContainer === 'urliving' ||
              window.PictureContainer === 'urliving-t'
            ) {
              getBrandRecommendData();
            }

            fireShopContentView({
              customMarketID: selectedFoodSpec.value.Product.CustomMarketID,
              name: selectedFoodSpec.value.Product.Name,
              price: selectedFoodSpec.value.Product.SellPrice,
              affiliation: userSelectFlavor.value.Name,
              item_brand: selectedFoodSpec.value.Name,
              eventName: selectedFoodSpec.value.Product.Events.length
                ? selectedFoodSpec.value.Product.Events[0].Name
                : '',
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      // pattern 為 1 和 3 都是一般賣場模式
      // pattern 為 3 為外部供應商自訂商品描述HTML
      getDataAPI({
        params: {
          CustomMarketID: window.CustomMarketID,
        },
      })
        .then((res) => {
          if (res.data.Code === 200) {
            itemDatas.value = res.data.Response;
            selectedDataID.value = res.data.Response.ColorID;

            if (itemDatas.value.IsPreShow) {
              btnStyleGenerate.value = btnStyleEnum.disabled;
              btnDescriptionGenerate.value = btnDescriptionEnum.preShow;
              pzBuyNow.value = btnDescriptionEnum.preShow;
            }

            dataIsLoad.value = true;

            if (
              window.PictureContainer === 'urliving' ||
              window.PictureContainer === 'urliving-t'
            ) {
              getBrandRecommendData();
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  // only for urliving
  const brandRecommendIsLoad = ref(false);
  const brandRecommendData = ref({});
  function getBrandRecommendData() {
    getBrandRecommendDataAPI({
      params: {
        OnlyFirstColor: true,
        Brand: itemDatas.value.Brand.Code,
        Page: 1,
        PageSize: 6,
      },
    })
      .then((res) => {
        if (res.data.Code === 200) {
          brandRecommendIsLoad.value = true;
          randomBrandSlideArray(res.data.Response.Data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function randomBrandSlideArray(arr) {
    let ctr = arr.length;
    let temp;
    let index;

    while (ctr > 0) {
      index = Math.floor(Math.random() * ctr);
      ctr -= 1;
      temp = arr[ctr];
      arr[ctr] = arr[index];
      arr[index] = temp;
    }
    brandRecommendData.value = arr;
  }

  // 奶油、URL、餐飲公版的推薦：'/api/v1/market'
  const recommendIsLoad = ref(false);
  const recommendData = ref({});
  function getRecommendData() {
    getRecommendDataAPI({
      params: {
        OnlyFirstColor: true,
        CategoryIDs: window.CategoryIDs?.toString(),
        Page: 1,
        PageSize: 6,
      },
    })
      .then((res) => {
        if (res.data.Code === 200) {
          recommendIsLoad.value = true;
          randomSlideArray(res.data.Response.Data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function randomSlideArray(arr) {
    let ctr = arr.length;
    let temp;
    let index;

    while (ctr > 0) {
      index = Math.floor(Math.random() * ctr);
      ctr -= 1;
      temp = arr[ctr];
      arr[ctr] = arr[index];
      arr[index] = temp;
    }
    recommendData.value = arr;
  }

  // 其餘品牌的推薦：'/api/v1/recommendation/getrelatedcategory'
  const marketRecommendIsLoad = ref(false);
  const marketRecommendData = ref([]);
  function getMarketRecommendData() {
    getMarketRecommendDataAPI({
      params: {
        CustomMarketID: window.CustomMarketID,
        CategoryIDs: window.CategoryIDs.toString(),
      },
    })
      .then((res) => {
        if (res.data.Code === 200) {
          marketRecommendData.value = res.data.Response.map((item) => {
            return {
              url: `${item.MarketUrl}&page=product&source=ur&recommend=related_to_category`,
              image: item.PictureUrl || '',
              originPrice: item.OriginPrice || 0,
              sellPrice: item.SellPrice || 0,
              sellPriceTW: item.SellPrice_TW || 0,
              eventPrice: item.EventPrice || 0,
              name: item.Name || '',
              customMarketID: item.CustomMarketID || '',
              color: item.ColorName || '',
              currentCurrency: item.CurrentCurrency,
            };
          });

          marketRecommendIsLoad.value = true;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const selectedData = ref({});
  const allSpecPreOrder = ref(false);
  const favCustomMarketID = computed(() => {
    if (Object.keys(itemDatas.value).length === 0) return undefined;
    if (pattern.value === 2) return selectedFoodSpec.value.Product.CustomMarketID;

    const substringID = itemDatas.value.CustomMarketID.substring(
      0,
      itemDatas.value.CustomMarketID.indexOf('CL'),
    );

    const customMarketID = `${substringID}CL${selectedData.value.ID}SZ_`;

    return customMarketID;
  });

  function getSelectedData() {
    selectedData.value = itemDatas.value.Colors.find((color) => color.ID === selectedDataID.value);
    const allSpecPreOrderArray = [];
    selectedData.value.Specs.forEach((element) => {
      allSpecPreOrderArray.push(element.PreOrder);
    });
    allSpecPreOrder.value = allSpecPreOrderArray.every(Boolean);

    if (selectedData.value.Specs.length === 1 && selectedData.value.Specs[0].Stock > 0) {
      selectSpec(selectedData.value.Specs[0]);
    }
  }

  const selectedSpec = ref(
    window.PictureContainer === 'urliving' || window.PictureContainer === 'urliving-t'
      ? { Name: '請選擇尺寸', Key: 'default', ID: 'default' }
      : { Name: '尺寸', Key: 'default', ID: 'default' },
  );
  const selectedSpecID = ref(0);
  const selectedSpecKey = ref(0);
  function selectSpec(spec) {
    if (spec.Key === 'default') {
      btnStyleGenerate.value = btnStyleEnum.disabled;
      btnDescriptionGenerate.value = btnDescriptionEnum.general;
      pzBuyNow.value = btnDescriptionEnum.general;

      clearSpec();
      resetCounter();
      return;
    }

    selectedSpec.value = spec;
    selectedSpecID.value = spec.ID;
    selectedSpecKey.value = spec.Key;

    resetCounter();
    getBtnStatus({
      stock: spec.Stock,
      isSoldOut: spec.IsOutOfStock,
      isPreOrder: spec.PreOrder,
    });
  }
  function clearSpec() {
    selectedSpec.value =
      window.PictureContainer === 'urliving' || window.PictureContainer === 'urliving-t'
        ? { Name: '請選擇尺寸', Key: 'default', ID: 'default' }
        : { Name: '尺寸', Key: 'default', ID: 'default' };
    selectedSpecID.value = 0;
    selectedSpecKey.value = 0;
  }

  const selectIsOpen = ref(false);
  function openSelector() {
    selectIsOpen.value = !selectIsOpen.value;
  }

  function changeImg(colorID) {
    console.log('changeImg', colorID);
    selectIsOpen.value = false;
    if (selectedData.value.ID === colorID) return;
    btnReset();
    clearSpec();
    resetCounter();
    selectedDataID.value = colorID;
  }

  function getBtnStatus(payload) {
    if (itemDatas.value.IsPreShow) return;

    if (window.PictureContainer === 'urliving' || window.PictureContainer === 'urliving-t') {
      if (payload.stock === 0) {
        if (payload.isPreOrder) {
          // 無庫存預購
          btnStyleGenerate.value = btnStyleEnum.disabled;
          btnDescriptionGenerate.value = btnDescriptionEnum.soldOut;
        } else {
          // 無庫存現貨
          btnStyleGenerate.value = btnStyleEnum.activeMail;
          btnDescriptionGenerate.value = btnDescriptionEnum.notice;
        }
      } else {
        btnStyleGenerate.value = btnStyleEnum.active;
        btnDescriptionGenerate.value = btnDescriptionEnum.addBag;
      }
      return;
    }

    if (payload.stock === 0 && payload.isSoldOut && !payload.isPreOrder) {
      // 現貨無庫存且斷貨
      btnStyleGenerate.value = btnStyleEnum.disabled;
      btnDescriptionGenerate.value = btnDescriptionEnum.soldOut;
      pzBuyNow.value = btnDescriptionEnum.soldOut;
    } else if (payload.stock === 0) {
      // 無庫存
      btnStyleGenerate.value = btnStyleEnum.activeMail;
      btnDescriptionGenerate.value = btnDescriptionEnum.notice;
      pzBuyNow.value = btnDescriptionEnum.notice;
    } else if (payload.isPreOrder && payload.stock > 0) {
      // 有預購按鈕文字
      btnStyleGenerate.value = btnStyleEnum.active;
      btnDescriptionGenerate.value = btnDescriptionEnum.addPre || btnDescriptionEnum.addBag;
      pzBuyNow.value = '立即結帳';
    } else {
      btnStyleGenerate.value = btnStyleEnum.active;
      btnDescriptionGenerate.value = btnDescriptionEnum.addBag;
      pzBuyNow.value = '立即結帳';
    }
  }
  function btnReset() {
    btnStyleGenerate.value = btnStyleEnum.disabled;
    btnDescriptionGenerate.value = btnDescriptionEnum.general;
    pzBuyNow.value = btnDescriptionEnum.general;
    if (itemDatas.value.IsPreShow) {
      btnDescriptionGenerate.value = btnDescriptionEnum.preShow;
      pzBuyNow.value = btnDescriptionEnum.preShow;
    }
  }

  const counter = ref(1);
  function addCount(payload) {
    // 還沒選尺寸或是即將開賣
    if (pattern.value !== 2 && selectedSpec.value.Key === 'default') return;
    if (pattern.value !== 2 && itemDatas.value.IsPreShow) return;
    if (pattern.value === 2 && selectedFoodSpec.value.Product.IsPreShow) return;
    if (counter.value >= payload.maxCount) return;
    if (counter.value >= payload.limit && payload.limit !== 0) return;
    counter.value += 1;
  }
  function reduceCount() {
    if (counter.value <= 1) return;
    counter.value -= 1;
  }
  function resetCounter() {
    counter.value = 1;
  }

  const CMID = ref('');

  /**
   * @param {boolean} noArrivalNotice - 是否有貨到通知
   */
  function addToCart(noArrivalNotice = false) {
    // 還沒選尺寸或是即將開賣
    if (pattern.value !== 2 && selectedSpec.value.Key === 'default') return;
    if (pattern.value !== 2 && itemDatas.value.IsPreShow) return;
    if (pattern.value === 2 && selectedFoodSpec.value.Product.IsPreShow) return;

    const customMarketID = itemDatas.value.CustomMarketID;
    const subStringCustomMarketID = customMarketID.substring(0, customMarketID.indexOf('CL'));
    const itemSpecInfo = `${subStringCustomMarketID}CL${selectedData.value.ID}SZ${selectedSpecKey.value}`;
    CMID.value = itemSpecInfo;

    // urliving 預購不顯示貨到通知
    // 其餘品牌 預購無庫存無斷貨顯示貨到通知
    if (window.PictureContainer === 'urliving' || window.PictureContainer === 'urliving-t') {
      if (selectedSpec.value.Stock === 0) {
        if (selectedSpec.value.PreOrder) {
          return;
        }
        openModal('ArrivalNotice', CMID.value);
        return;
      }
    } else {
      if (btnDescriptionGenerate.value === btnDescriptionEnum.notice && noArrivalNotice) {
        return;
      }
      if (
        selectedSpec.value.Stock === 0 &&
        selectedSpec.value.IsOutOfStock &&
        !selectedSpec.value.PreOrder
      ) {
        return;
      }
      if (selectedSpec.value.Stock === 0) {
        openModal('ArrivalNotice', CMID.value);
        return;
      }
    }

    const utmData = utmKDetect(itemSpecInfo) === null ? '' : utmKDetect(itemSpecInfo);
    // eslint-disable-next-line consistent-return
    return new Promise((resolve, reject) => {
      postShoppingCartAPI({
        CustomMarketID: itemSpecInfo,
        Count: counter.value,
        UtmTag: utmData,
        ShareCode: shareCode() === null ? null : shareCode(),
      })
        .then((res) => {
          if (res.data.Code === 200) {
            messageBox.cart('商品確認<br>已加入購物車');
            getCartInfo();
            closeMobileCartDialog();

            gtmTrace.addToCart({
              name: itemDatas.value.Name,
              id: itemSpecInfo,
              price: itemDatas.value.OriginPrice,
              sale_price:
                itemDatas.value.EventPrice > 0 &&
                itemDatas.value.EventPrice < itemDatas.value.SellPrice
                  ? itemDatas.value.EventPrice
                  : itemDatas.value.SellPrice,
              img_url: selectedData.value.Images[0].Url,
              product_url: selectedData.value.MarketUrl,
              color: selectedData.value.Name,
              count: counter.value,
            });

            fireAddToCart({
              item_id: itemSpecInfo.split('SZ')[0],
              item_name: itemDatas.value.Name,
              index: 0,
              affiliation: selectedData.value.Name,
              item_brand: selectedSpec.value.Name,
              item_list_name: listName.value,
              price:
                itemDatas.value.EventPrice > 0 &&
                itemDatas.value.EventPrice < itemDatas.value.SellPrice
                  ? itemDatas.value.EventPrice
                  : itemDatas.value.SellPrice,
              quantity: counter.value,
              item_variant: selectedSpec.value.Barcode,
            });

            resolve({ code: 200 });
          } else if (res.data.Code === 205) {
            resolve({ code: 205 });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  function closeMobileCartDialog() {
    isOpenCartDialog.value = false;
  }
  function showMobileCartDialog() {
    isOpenCartDialog.value = true;
  }

  /**
   * @description 取得 user 選擇的口味和規格
   * @param {boolean} type - 是否為 user 手動變更口味，若否則預設點擊商品的口味
   */
  function setSelectedFood(payload) {
    if (payload.type === false) {
      userSelectFlavor.value = payload.foodFlavors.find((flavor) => flavor.Selected);
      selectedFoodSpec.value = userSelectFlavor.value.Specs.find((spec) => spec.Selected);
    } else {
      const checkHasStock = userSelectFlavor.value.Specs.find((stock) => stock.Stock > 0);

      if (checkHasStock) {
        selectedFoodSpec.value = checkHasStock;
      } else {
        const { Specs } = userSelectFlavor.value;
        const [foodSpec] = Specs;
        selectedFoodSpec.value = foodSpec;
      }
    }
  }

  function selectFoodSpec(spec) {
    selectedFoodSpec.value = spec;

    resetCounter();
    foodBtnStyleGenerate();
    changeFoodAddonID();

    fireShopContentView({
      affiliation: userSelectFlavor.value.Name,
      item_brand: selectedFoodSpec.value.Name,
      customMarketID: selectedFoodSpec.value.Product.CustomMarketID,
      eventName: selectedFoodSpec.value.Product.Events.length
        ? selectedFoodSpec.value.Product.Events[0].Name
        : '',
      name: selectedFoodSpec.value.Product.Name,
      price: selectedFoodSpec.value.Product.SellPrice,
    });
  }

  function changeFlavor(flavorIndex) {
    if (itemDatas.value.Flavors[flavorIndex].Name === userSelectFlavor.value.Name) return;

    selectIsOpen.value = false;
    userSelectFlavor.value = itemDatas.value.Flavors[flavorIndex];
    setSelectedFood({ foodFlavors: userSelectFlavor.value, type: true });

    resetCounter();
    foodBtnStyleGenerate();
    changeFoodAddonID();

    fireShopContentView({
      affiliation: userSelectFlavor.value.Name,
      item_brand: selectedFoodSpec.value.Name,
      customMarketID: selectedFoodSpec.value.Product.CustomMarketID,
      eventName: selectedFoodSpec.value.Product.Events.length
        ? selectedFoodSpec.value.Product.Events[0].Name
        : '',
      name: selectedFoodSpec.value.Product.Name,
      price: selectedFoodSpec.value.Product.SellPrice,
    });
  }

  const foodBtnStyle = ref(btnStyleEnum.disabled);
  const foodBtnDescription = ref(btnFoodDescriptionEnum.general);
  function foodBtnStyleGenerate() {
    if (selectedFoodSpec.value.Product.IsPreShow) {
      foodBtnStyle.value = btnStyleEnum.disabled;
      foodBtnDescription.value = btnFoodDescriptionEnum.preShow;
      return;
    }

    if (window.PictureContainer === 'urliving' || window.PictureContainer === 'urliving-t') {
      if (selectedFoodSpec.value.Stock === 0) {
        if (selectedFoodSpec.value.Product.PreOrder) {
          foodBtnStyle.value = btnStyleEnum.disabled;
          foodBtnDescription.value = btnFoodDescriptionEnum.soldOut;
        } else {
          foodBtnStyle.value = btnStyleEnum.activeMail;
          foodBtnDescription.value = btnFoodDescriptionEnum.notice;
        }
      } else {
        foodBtnStyle.value = btnStyleEnum.active;
        foodBtnDescription.value = btnFoodDescriptionEnum.addBag;
      }
      return;
    }

    if (
      selectedFoodSpec.value.Stock === 0 &&
      selectedFoodSpec.value.Product.IsOutOfStock &&
      !selectedFoodSpec.value.Product.PreOrder
    ) {
      // 無庫存且斷貨但是為現貨
      foodBtnStyle.value = btnStyleEnum.disabled;
      foodBtnDescription.value = btnFoodDescriptionEnum.soldOut;
    } else if (selectedFoodSpec.value.Stock === 0) {
      foodBtnStyle.value = btnStyleEnum.activeMail;
      foodBtnDescription.value = btnFoodDescriptionEnum.notice;
    } else {
      foodBtnStyle.value = btnStyleEnum.active;
      foodBtnDescription.value = btnFoodDescriptionEnum.addBag;
    }
  }

  function foodAddToCart() {
    if (selectedFoodSpec.value === null) {
      alertDialog.alert(btnFoodDescriptionEnum.general);
      return;
    }

    CMID.value = selectedFoodSpec.value.Product.CustomMarketID;

    // urliving 預購不顯示貨到通知
    // 其餘品牌 預購無庫存無斷貨顯示貨到通知
    if (window.PictureContainer === 'urliving' || window.PictureContainer === 'urliving-t') {
      if (selectedFoodSpec.value.Stock === 0) {
        if (selectedFoodSpec.value.Product.PreOrder) {
          return;
        }
        openModal('ArrivalNotice', CMID.value);
        return;
      }
    } else {
      if (selectedFoodSpec.value.Product.IsOutOfStock && !selectedFoodSpec.value.Product.PreOrder) {
        return;
      }
      if (selectedFoodSpec.value.Stock === 0) {
        openModal('ArrivalNotice', CMID.value);
        return;
      }
    }

    const utmData =
      utmKDetect(selectedFoodSpec.value.Product.CustomMarketID) === null
        ? ''
        : utmKDetect(selectedFoodSpec.value.Product.CustomMarketID);
    // eslint-disable-next-line consistent-return
    return new Promise((resolve, reject) => {
      postShoppingCartAPI({
        CustomMarketID: selectedFoodSpec.value.Product.CustomMarketID,
        Count: counter.value,
        UtmTag: utmData,
        ShareCode: shareCode() === null ? null : shareCode(),
      })
        .then((res) => {
          if (res.data.Code === 200) {
            getCartInfo();
            closeMobileCartDialog();

            gtmTrace.addToCart({
              name: selectedFoodSpec.value.Product.Name,
              id: selectedFoodSpec.value.Product.CustomMarketID,
              price: selectedFoodSpec.value.Product.OriginPrice,
              sale_price:
                selectedFoodSpec.value.Product.EventPrice > 0 &&
                selectedFoodSpec.value.Product.EventPrice < selectedFoodSpec.value.Product.SellPrice
                  ? selectedFoodSpec.value.Product.EventPrice
                  : selectedFoodSpec.value.Product.SellPrice,
              img_url: selectedFoodSpec.value.Product.Images[0].Url,
              product_url: selectedFoodSpec.value.Product.MarketUrl,
              color: userSelectFlavor.value.Name,
              count: counter.value,
            });

            fireAddToCart({
              item_id: selectedFoodSpec.value.Product.CustomMarketID.split('SZ')[0],
              item_name: selectedFoodSpec.value.Product.Name,
              index: 0,
              affiliation: userSelectFlavor.value.Name,
              item_brand: selectedFoodSpec.value.Name,
              item_list_name: '產品內頁',
              price: selectedFoodSpec.value.Product.SellPrice,
              quantity: counter.value,
              item_variant: '',
            });

            resolve({ code: 200 });
          } else if (res.data.Code === 205) {
            resolve({ code: 205 });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  const foodAddonID = ref(
    window.CustomMarketID
      ? window.CustomMarketID.substring(0, window.CustomMarketID.indexOf('CL'))
      : null,
  );
  function changeFoodAddonID() {
    const originID = selectedFoodSpec.value.Product.CustomMarketID;
    foodAddonID.value = originID.substring(0, originID.indexOf('CL'));
  }

  function toggleFoodFavorite(isFavorite) {
    if (isFavorite) {
      deleteFavoriteAPI({
        data: {
          CustomMarketID: favCustomMarketID.value,
        },
      })
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              selectedFoodSpec.value.IsFavorite = false;
              selectedFoodSpec.value.FavoriteAmount -= 1;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      postFavoriteAPI({
        CustomMarketID: favCustomMarketID.value,
      })
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              selectedFoodSpec.value.IsFavorite = true;
              selectedFoodSpec.value.FavoriteAmount += 1;
              fireWishlistEvent({
                color: userSelectFlavor.value.Name,
                id: favCustomMarketID.value,
                name: selectedFoodSpec.value.Product.Name,
                sellPrice: selectedFoodSpec.value.Product.SellPrice,
                size: selectedFoodSpec.value.Name || '',
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  function toggleFavorite(isFavorite) {
    if (isFavorite) {
      deleteFavoriteAPI({
        data: {
          CustomMarketID: favCustomMarketID.value,
        },
      })
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              selectedData.value.IsFavorite = false;
              selectedData.value.FavoriteCount -= 1;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      postFavoriteAPI({
        CustomMarketID: favCustomMarketID.value,
      })
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              selectedData.value.IsFavorite = true;
              selectedData.value.FavoriteCount += 1;
              fireWishlistEvent({
                color: selectedData.value.Name,
                id: favCustomMarketID.value,
                name: itemDatas.value.Name,
                sellPrice: itemDatas.value.SellPrice,
                size: selectedSpec.value.Name || '',
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  return {
    itemDatas,
    selectedSpecID,
    selectedDataID,
    selectedData,
    recommendData,
    marketRecommendData,
    brandRecommendData,
    dataIsLoad,
    recommendIsLoad,
    marketRecommendIsLoad,
    brandRecommendIsLoad,
    CMID,
    selectedSpec,
    selectedSpecKey,
    counter,
    btnStyleGenerate,
    btnDescriptionGenerate,
    foodBtnStyle,
    foodBtnDescription,
    pzBuyNow,
    selectIsOpen,
    userSelectFlavor,
    selectedFoodSpec,
    isOpenCartDialog,
    allSpecPreOrder,
    pattern,
    foodAddonID,
    favCustomMarketID,
    isOpenStockDialog,
    getDataFromId,
    getData,
    getBrandRecommendData,
    randomBrandSlideArray,
    getRecommendData,
    getMarketRecommendData,
    randomSlideArray,
    getSelectedData,
    selectSpec,
    clearSpec,
    openSelector,
    changeImg,
    getBtnStatus,
    btnReset,
    addToCart,
    addCount,
    reduceCount,
    resetCounter,
    closeMobileCartDialog,
    showMobileCartDialog,
    setSelectedFood,
    selectFoodSpec,
    changeFlavor,
    foodBtnStyleGenerate,
    foodAddToCart,
    changeFoodAddonID,
    toggleFoodFavorite,
    toggleFavorite,
  };
});

export default useShopContentStore;
